var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-2 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2353 16.8125V13.2253C17.551 13.0652 17.8467 12.8719 18.1176 12.65V16.8125C18.1176 18.0206 17.13 19 15.9118 19H6.20588C4.98761 19 4 18.0206 4 16.8125V9.8125C4 8.60438 4.98761 7.625 6.20588 7.625H10.3591C10.2787 7.907 10.2236 8.19952 10.1963 8.5H6.20588C5.47491 8.5 4.88235 9.08762 4.88235 9.8125V10.0767L11.0588 13.6799L12.3306 12.9378C12.6171 13.1282 12.9251 13.2891 13.2502 13.4163L11.2825 14.5646C11.1674 14.6317 11.0294 14.6429 10.9066 14.5981L10.8351 14.5646L4.88235 11.0926V16.8125C4.88235 17.5373 5.47491 18.125 6.20588 18.125H15.9118C16.6427 18.125 17.2353 17.5373 17.2353 16.8125ZM11.0588 8.9375C11.0588 11.1121 12.8365 12.875 15.0294 12.875C17.2223 12.875 19 11.1121 19 8.9375C19 6.76288 17.2223 5 15.0294 5C12.8365 5 11.0588 6.76288 11.0588 8.9375ZM15.8204 6.65939C15.9927 6.48853 16.272 6.48853 16.4444 6.65939L17.9885 8.19064C18.0307 8.23259 18.0627 8.28094 18.0842 8.33253C18.1057 8.38411 18.1176 8.44068 18.1176 8.5C18.1176 8.55932 18.1057 8.61589 18.0842 8.66747C18.0629 8.7183 18.0317 8.76598 17.9903 8.8075L16.4444 10.3406C16.272 10.5115 15.9927 10.5115 15.8204 10.3406C15.6481 10.1698 15.6481 9.89275 15.8204 9.72189L16.6114 8.9375H15.25C14.3972 8.9375 13.7059 9.62306 13.7059 10.4688V10.6875C13.7059 10.9291 13.5083 11.125 13.2647 11.125C13.0211 11.125 12.8235 10.9291 12.8235 10.6875V10.4688C12.8235 9.13982 13.9099 8.0625 15.25 8.0625H16.6114L15.8204 7.27811C15.6481 7.10725 15.6481 6.83025 15.8204 6.65939Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/SendEmail.673786ea0707d310a77a1550528ea0ad.svg";
export { ForwardRef as ReactComponent };